import { LibraryExercise } from '.';
import { Language } from './translations';
import { LocalizedExerciseTitles } from './workout/shared';

export type LocalizableExerciseTemplate =
  | { is_custom: true; title: string }
  | ({
      is_custom?: false;
    } & Pick<LibraryExercise, 'title' | keyof LocalizedExerciseTitles | 'localised_instructions'>);

export const localisedExerciseTitle = (locale: Language, template: LocalizableExerciseTemplate) => {
  if (template.is_custom) {
    return template.title;
  }

  return (
    localeSelect(locale, {
      en: template.title,
      es: template.es_title,
      de: template.de_title,
      fr: template.fr_title,
      it: template.it_title,
      pt_PT: template.pt_title,
      tr: template.tr_title,
      zh_CN: template.zh_cn_title,
      zh_TW: template.zh_tw_title,
      ru: template.ru_title,
      ja: template.ja_title,
      ko: template.ko_title,
      ar: template.ar_title,
      ca: template.ca_title,
      hi: template.hi_title,
      pl: template.pl_title,
      pt_BR: template.pt_br_title,
    }) ?? template.title
  );
};

export const localisedExerciseInstructions = (
  locale: Language,
  exerciseTemplate: LocalizableExerciseTemplate,
) => {
  if (exerciseTemplate.is_custom) {
    return '';
  }

  return localeSelect(locale, {
    en: exerciseTemplate?.localised_instructions?.en ?? '',
    pt_PT: exerciseTemplate?.localised_instructions?.pt_PT,
    de: exerciseTemplate?.localised_instructions?.de,
    es: exerciseTemplate?.localised_instructions?.es,
    it: exerciseTemplate?.localised_instructions?.it,
    fr: exerciseTemplate?.localised_instructions?.fr,
    ca: exerciseTemplate?.localised_instructions?.ca,
    pt_BR: exerciseTemplate?.localised_instructions?.pt_BR,
    tr: exerciseTemplate?.localised_instructions?.tr,
    zh_CN: exerciseTemplate?.localised_instructions?.zh_CN,
    zh_TW: exerciseTemplate?.localised_instructions?.zh_TW,
    ru: exerciseTemplate?.localised_instructions?.ru,
    ja: exerciseTemplate?.localised_instructions?.ja,
    ko: exerciseTemplate?.localised_instructions?.ko,
    ar: exerciseTemplate?.localised_instructions?.ar,
    hi: exerciseTemplate?.localised_instructions?.hi,
    pl: exerciseTemplate?.localised_instructions?.pl,
  });
};

export const localeSelect = <T>(
  locale: Language,
  options: { en: T } & { [language in Exclude<Language, 'en'>]?: T | null },
): T => {
  return options[locale] ?? options.en;
};
